export default __webpack_public_path__ + "static/media/06.190ad8a6.jpg";